import React, { useState, useEffect } from 'react'
import Image from 'next/image'

export default function AdvisorsSection() {
  const [currentAdvisor, setCurrentAdvisor] = useState(0)
  const [isTransitioning, setIsTransitioning] = useState(false)
  
  const advisors = [
    {
      id: 0,
      name: "Michael Kitces",
      title: "Advisor, Blogger, Industry Thought Leader",
      quote: "The CKA<sup style='font-size: 16px;'>®</sup> designation perfectly aligns to the emerging industry trend that the future of independent advisors is all about creating differentiated expertise and customized advice services...",
      image: "/static/images/cka_landing/Kitces_368x400 transparent.png"
      
    },
    {
      id: 1,
      name: "Tim Macready",
      title: "Founder, Brightlight Impact",
      quote: "We see faith-based clients increasingly seeking values-based investing guidance. Kingdom Advisors equips advisors to help their clients align investment portfolios with what matters most to them.",
      image: "/static/images/cka_landing/Macready_368x400.png"
    },
    {
      id: 2,
      name: "David Bahnsen",
      title: "CIO, The Bahnsen Group",
      quote: "Wisdom of a 'multitude of counselors' is found in Kingdom Advisors resources.",
      image: "/static/images/cka_landing/Bahnsen_368x400.png"
    }
  ]

  // Auto-rotation effect
  useEffect(() => {
    const interval = setInterval(() => {
      setIsTransitioning(true)
      setTimeout(() => {
        setCurrentAdvisor((prev) => (prev + 1) % advisors.length)
        setIsTransitioning(false)
      }, 800) // Half of the transition duration
    }, 10000) // 5 seconds

    return () => clearInterval(interval)
  }, [advisors.length])

  const handleBarClick = (index) => {
    if (index !== currentAdvisor) {
      setIsTransitioning(true)
      setTimeout(() => {
        setCurrentAdvisor(index)
        setIsTransitioning(false)
      }, 1200) // Half of the transition duration
    }
  }

  return (
    <div className="w-full flex-shrink min-h-[600px] py-14 md:h-[704px] relative overflow-hidden bg-[#192f5c]">
      {/* Fixed position arrows */}
      <div className="absolute left-0 top-0 w-full h-full pointer-events-none hidden md:block">
        {/* Left arrow - centered vertically, half visible */}
        <div className="absolute left-0 top-1/2 transform -translate-y-1/2  overflow-hidden" style={{
          marginTop:-75,
          marginLeft:-50, width:290, height:290 }}>
          <Image
            src="/static/images/cka_landing/advisor/left.png"
            alt="Left arrow"
            width={290}
            height={290}
            className="w-full h-full object-contain "
          />
        </div>
        {/* Right arrow - bottom right with padding */}
        <div className="absolute right-0 bottom-8  overflow-hidden" style={{ width:290, height:290 }}>
          <Image
            src="/static/images/cka_landing/advisor/right.png"
            alt="Right arrow"
            width={290}
            height={290}
            className="w-full h-full object-contain"
          />
        </div>
      </div>

      {/* Main content - centered */}
      <div className="md:absolute md:inset-0 flex justify-center items-center px-4">
        <div className="w-full max-w-[892px] flex flex-col justify-center items-center gap-8 md:gap-14">
        <div className={`w-full flex flex-col md:flex-row justify-center items-center gap-8 md:gap-12 transition-all duration-1200 ease-in-out ${
          isTransitioning ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
        }`}>
          {/* Mobile: Quote first, then image, then attribution */}
          <div className="w-full md:hidden flex flex-col items-center gap-6 "  >
            {/* Quote */}
            <div className="text-center" style={{minHeight:260}}>
              <span className="text-white text-2xl md:text-3xl font-medium font-['Lora']" dangerouslySetInnerHTML={{
                __html: `&ldquo;${advisors[currentAdvisor].quote}&rdquo;`
              }} />
            </div>
            
            {/* Advisor Image */}
            <div className="w-32 h-32 relative">
              <Image
                src={advisors[currentAdvisor].image}
                alt={advisors[currentAdvisor].name}
                width={128}
                height={128}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            
            {/* Attribution */}
            <div className="text-center flex flex-col gap-2">
              <div className="text-orange-300 text-base font-normal font-['Instrument-Sans'] uppercase">
                - {advisors[currentAdvisor].name}
              </div>
              <div className="text-white text-base font-normal font-['Instrument-Sans']">
                {advisors[currentAdvisor].title}
              </div>
            </div>
          </div>

          {/* Desktop: Image and quote side by side */}
          <div className="hidden md:flex w-full items-start gap-12" style={{minHeight:276,}}>
            {/* Advisor Image */}
            <div className="w-44 h-48 relative">
              <Image
                src={advisors[currentAdvisor].image}
                alt={advisors[currentAdvisor].name}
                width={176}
                height={192}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            
            {/* Quote and Attribution */}
            <div className="flex-1 flex flex-col justify-start items-start gap-10">
              <div className="self-stretch justify-start">
                <span className="text-white text-3xl font-medium font-['Lora']" dangerouslySetInnerHTML={{
                  __html: `&ldquo;${advisors[currentAdvisor].quote}&rdquo;`
                }} />
              </div>
              <div className="self-stretch flex flex-col justify-start items-start gap-2">
                <div className="self-stretch justify-start text-orange-300 text-base font-normal font-['Instrument-Sans'] uppercase">
                  - {advisors[currentAdvisor].name}
                </div>
                <div className="self-stretch justify-start text-white text-base font-normal font-['Instrument-Sans']">
                  {advisors[currentAdvisor].title}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Navigation bars */}
        <div className="inline-flex justify-start items-center gap-1.5">
          {advisors.map((_, index) => (
            <button
              key={index}
              onClick={() => handleBarClick(index)}
              className={`border-0 outline-none w-14 h-[3px] transition-colors duration-300 ${
                index === currentAdvisor 
                  ? 'bg-[#27739a]' 
                  : 'bg-[#75829d]'
              }`}
              aria-label={`Go to ${advisors[index].name} testimonial`}
            />
          ))}
        </div>
        </div>
      </div>
    </div>
  )
}
